import { createElement } from 'react';
const WHITELISTED_HTML_TAGS = ['b', 'div', 'i', 'li', 'ol', 'p', 'span', 'strong', 'ul', 'u'];
export const defaultInterpolations = WHITELISTED_HTML_TAGS.reduce((accumulator, tag) => {
  accumulator[tag] = chunks => /*#__PURE__*/createElement(tag, null, chunks);

  return accumulator;
}, {}); // Pluralize functions are based on config/locales/plurals.rb

const ltPluralize = count => {
  if (count % 10 === 1 && count % 100 !== 11) return 'one';
  return [2, 3, 4, 5, 6, 7, 8, 9].includes(count % 10) && ![11, 12, 13, 14, 15, 16, 17, 18, 19].includes(count % 100) ? 'few' : 'other';
};

const czPluralize = count => {
  if (count === 1) return 'one';
  return [2, 3, 4].includes(count) ? 'few' : 'other';
};

const plPluralize = count => {
  if (count === 1) return 'one';
  return [2, 3, 4].includes(count % 10) && ![12, 13, 14].includes(count % 100) ? 'few' : 'other';
};

const roPluralize = count => {
  if (count === 1) return 'one';
  return count >= 20 ? 'other' : 'few';
};

const huPluralize = () => 'one';

const frPluralize = count => count <= 1 ? 'one' : 'other';

const skPluralize = count => {
  if (count === 1) return 'one';
  return [2, 3, 4].includes(count) ? 'other' : 'few';
};

const defaultPluralize = count => count === 1 ? 'one' : 'other';

const pluralFunctionMap = {
  lt: ltPluralize,
  cz: czPluralize,
  pl: plPluralize,
  ro: roPluralize,
  hu: huPluralize,
  fr: frPluralize,
  sk: skPluralize
};
export const pluralization = locale => {
  const pluralizationFunction = pluralFunctionMap[locale];
  return pluralizationFunction !== null && pluralizationFunction !== void 0 ? pluralizationFunction : defaultPluralize;
};